"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  id: 'language-masters_en_1549036561649',
  resourceType: 'Standard_Hero_1_0_0',
  textBlockPosition: 'center',
  featureBlock: [],
  theme: 'dark',
  __typename: 'FullWidthPanel',
  navigationLinks: []
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;